export const BASE_URL = '/products/sync-all-to-crm';
